<template>
  <el-dialog class="confirm-dialog dialog-base" :title="title" :visible="visible" append-to-body :modal="true" :width="$store.getters.isMobile ? '80%' : '420px'" @close="$emit('update:visible', false)">
    <div class="confirm-dialog__content">
      <div class="message">{{ message }}</div>
      <div class="actions">
        <button class="dialog-btn cancel" @click="$emit('cancel')">{{ cancelText }}</button>
        <button class="dialog-btn confirm" @click="$emit('confirm')">{{ confirmText }}</button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { Dialog } from 'element-ui'
export default {
  name: 'ConfirmDialog',
  components: { [Dialog.name]: Dialog },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    message: { type: String, default: '' },
    confirmText: { type: String, default: '确认' },
    cancelText: { type: String, default: '取消' }
  }
}
</script>
<style lang="less">
@import './dialogBase.less';
.confirm-dialog {
  .el-dialog__body { padding: 24px; }
  &__content {
    .title { font-size: 18px; font-weight: 700; text-align: center; color: #111; }
    .message { font-size: 14px; color: #333; text-align: center; }
    .actions { margin-top: 20px; text-align: center; }
  }
}
</style>
